if (!customElements.get('buy-three-pay-two')) {
  customElements.define(
    'buy-three-pay-two',
    class BuyThreePayTwo extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.sectionId = this.dataset.sectionId;
        this.currentProductId = this.dataset.currentProductId;
        this.currentVariantId = this.dataset.currentVariantId;
        this.tabs = this.querySelector('[data-purchase-mode-tabs]');
        this.standardButton = this.tabs?.querySelector('[data-purchase-mode="standard"]');
        this.bundleButton = this.tabs?.querySelector('[data-purchase-mode="bundle"]');
        this.bundlePanel = this.querySelector('[data-bundle-panel]');
        this.addButton = this.querySelector('[data-bundle-submit]');
        this.errorElement = this.querySelector('[data-bundle-error]');
        this.regularTotalElement = this.querySelector('[data-bundle-regular-total]');
        this.bundleTotalElement = this.querySelector('[data-bundle-total]');
        this.savingsElement = this.querySelector('[data-bundle-savings]');
        this.priceSummary = this.querySelector('[data-bundle-price-summary]');
        this.productInfo = this.closest('product-info');
        this.buyButtonsBlock = this.closest('.product__block--buy_buttons');
        this.originalVisibility = new Map();
        this.standardElements = [];

        const productsJson = this.querySelector('[data-bundle-products]');
        try {
          this.products = JSON.parse(productsJson?.textContent || '[]');
        } catch (error) {
          this.products = [];
          console.error(error);
        }

        this.standardButton?.addEventListener('click', () => this.setMode('standard'));
        this.bundleButton?.addEventListener('click', () => this.setMode('bundle'));
        this.addButton?.addEventListener('click', () => this.addBundle());

        try {
          this.refreshStandardElements();
        } catch (error) {
          console.error('Could not resolve the standard product controls.', error);
        }

        this.querySelectorAll('[data-bundle-slot]').forEach((slot) => {
          slot.querySelector('[data-product-select]')?.addEventListener('change', (event) => {
            this.updateVariantSelect(slot, event.currentTarget.value);
          });
          slot.querySelector('[data-variant-select]')?.addEventListener('change', () => {
            this.updateSlot(slot);
          });
        });

        this.handlePageVariantChange = (event) => {
          const variantId = event.detail?.variant?.id;
          if (!variantId) return;
          this.currentVariantId = String(variantId);
          const firstSlot = this.querySelector('[data-bundle-slot]');
          const productSelect = firstSlot?.querySelector('[data-product-select]');
          if (String(productSelect?.value) !== String(this.currentProductId)) return;
          this.updateVariantSelect(firstSlot, this.currentProductId, this.currentVariantId, true);
        };
        document.addEventListener('variant:changed', this.handlePageVariantChange);

        if (this.tabs) {
          if (this.variantBlock) {
            this.variantBlock.before(this.tabs);
          } else if (this.buyButtonsBlock) {
            this.buyButtonsBlock.before(this.tabs);
          }
        }

        try {
          this.initializeFirstSlot();
        } catch (error) {
          console.error('Could not preselect the first bundle product.', error);
        }
        this.setMode('bundle');
        this.updateSummary();
      }

      disconnectedCallback() {
        document.removeEventListener('variant:changed', this.handlePageVariantChange);
      }

      setMode(mode) {
        const showBundle = mode === 'bundle';

        this.standardButton?.classList.toggle('is-active', !showBundle);
        this.standardButton?.setAttribute('aria-selected', String(!showBundle));
        this.bundleButton?.classList.toggle('is-active', showBundle);
        this.bundleButton?.setAttribute('aria-selected', String(showBundle));
        if (this.bundlePanel) this.bundlePanel.hidden = !showBundle;

        try {
          this.refreshStandardElements();
          this.standardElements.forEach((element) => this.setElementVisibility(element, showBundle));
          if (this.stickyAtc) this.setElementVisibility(this.stickyAtc, showBundle);
        } catch (error) {
          console.error('Could not toggle the standard product controls.', error);
        }
      }

      refreshStandardElements() {
        this.variantBlock = this.productInfo?.querySelector('.product__block--variant_picker');
        const standardProductForm =
          this.productInfo?.querySelector(`form[id="product-form-${this.sectionId}"]`) ||
          this.buyButtonsBlock?.querySelector('form[is="product-form"]');
        this.standardForm = standardProductForm?.closest('.product-form');
        this.stickyAtc = document.getElementById('shopify-section-sticky-atc-bar');
        this.standardElements = [
          this.variantBlock,
          this.standardForm,
          standardProductForm,
          standardProductForm?.querySelector('.product-form__buttons'),
          this.productInfo?.querySelector('.product__block--inventory'),
          this.productInfo?.querySelector('.product__block--sku'),
          this.productInfo?.querySelector('.product__block--pickup_availability'),
        ].filter(Boolean);

        [...this.standardElements, this.stickyAtc].filter(Boolean).forEach((element) => {
          if (this.originalVisibility.has(element)) return;
          this.originalVisibility.set(element, {
            hidden: element.hidden,
            hasHiddenClass: element.classList.contains('hidden'),
            inlineDisplay: element.style.getPropertyValue('display'),
            inlineDisplayPriority: element.style.getPropertyPriority('display'),
          });
        });
      }

      setElementVisibility(element, shouldHide) {
        const originalState = this.originalVisibility.get(element) || {
          hidden: false,
          hasHiddenClass: false,
          inlineDisplay: '',
          inlineDisplayPriority: '',
        };

        if (shouldHide) {
          element.hidden = true;
          element.classList.add('hidden');
          element.style.setProperty('display', 'none', 'important');
          return;
        }

        element.hidden = originalState.hidden;
        element.classList.toggle('hidden', originalState.hasHiddenClass);
        if (originalState.inlineDisplay) {
          element.style.setProperty(
            'display',
            originalState.inlineDisplay,
            originalState.inlineDisplayPriority
          );
        } else {
          element.style.removeProperty('display');
        }
      }

      initializeFirstSlot() {
        const firstSlot = this.querySelector('[data-bundle-slot]');
        const productSelect = firstSlot?.querySelector('[data-product-select]');
        if (!firstSlot || !productSelect) return;

        const hasAvailableVariant = (product) => product?.variants?.some((variant) => variant.available);
        let initialProduct = this.products.find(
          (product) => String(product.id) === String(this.currentProductId) && hasAvailableVariant(product)
        );
        let preferredVariantId = this.currentVariantId;

        if (!initialProduct) {
          initialProduct = this.products.find((product) => product.available && hasAvailableVariant(product));
          preferredVariantId = '';
        }

        if (!initialProduct) return;

        productSelect.value = String(initialProduct.id);
        this.updateVariantSelect(firstSlot, initialProduct.id, preferredVariantId, true);
      }

      updateVariantSelect(slot, productId, preferredVariantId = '', selectFirstAvailable = false) {
        const variantSelect = slot.querySelector('[data-variant-select]');
        const hiddenInput = slot.querySelector('[data-variant-id]');
        const product = this.products.find((item) => String(item.id) === String(productId));
        const placeholder = variantSelect.dataset.placeholder;

        variantSelect.replaceChildren(new Option(placeholder, ''));
        hiddenInput.value = '';
        hiddenInput.disabled = true;
        this.updateProductImage(slot, product);

        if (!product) {
          variantSelect.disabled = true;
          this.updateSummary();
          return;
        }

        product.variants.forEach((variant) => {
          const option = new Option(variant.title, variant.id);
          option.disabled = !variant.available;
          option.dataset.price = variant.price;
          variantSelect.add(option);
        });

        variantSelect.disabled = false;
        const availableVariants = product.variants.filter((variant) => variant.available);
        const preferredVariant = availableVariants.find(
          (variant) => String(variant.id) === String(preferredVariantId)
        );
        const variantToSelect =
          preferredVariant ||
          (selectFirstAvailable || availableVariants.length === 1 ? availableVariants[0] : null);

        if (variantToSelect) {
          variantSelect.value = String(variantToSelect.id);
          this.updateSlot(slot);
        } else {
          this.updateSummary();
        }
      }

      updateProductImage(slot, product) {
        const imageWrapper = slot.querySelector('[data-product-image-wrapper]');
        const image = slot.querySelector('[data-product-image]');
        const placeholder = slot.querySelector('[data-product-image-placeholder]');
        const hasImage = Boolean(product?.image?.src);

        imageWrapper.hidden = false;
        image.hidden = !hasImage;
        placeholder.hidden = hasImage;
        if (!hasImage) {
          image.removeAttribute('src');
          image.alt = '';
          return;
        }

        image.src = product.image.src;
        image.alt = product.image.alt || product.title;
      }

      updateSlot(slot) {
        const variantSelect = slot.querySelector('[data-variant-select]');
        const hiddenInput = slot.querySelector('[data-variant-id]');
        const selectedOption = variantSelect.options[variantSelect.selectedIndex];

        hiddenInput.value = variantSelect.value;
        hiddenInput.disabled = !variantSelect.value;
        hiddenInput.dataset.price = selectedOption?.dataset.price || '';
        this.updateSummary();
      }

      getSelections() {
        return [...this.querySelectorAll('[data-variant-id]')]
          .filter((input) => !input.disabled && input.value)
          .map((input) => ({
            id: Number(input.value),
            price: Number(input.dataset.price),
          }));
      }

      updateSummary() {
        const selections = this.getSelections();
        const isComplete = selections.length === 3;
        this.addButton.disabled = !isComplete;
        this.priceSummary.hidden = !isComplete;

        if (!isComplete) return;

        const regularTotal = selections.reduce((sum, item) => sum + item.price, 0);
        const savings = Math.min(...selections.map((item) => item.price));
        const bundleTotal = regularTotal - savings;

        this.regularTotalElement.textContent = this.formatMoney(regularTotal);
        this.bundleTotalElement.textContent = this.formatMoney(bundleTotal);
        this.savingsElement.textContent = this.formatMoney(savings);
      }

      formatMoney(cents) {
        if (window.FoxTheme?.Currency?.formatMoney) {
          return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
        }
        return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'EUR',
        }).format(cents / 100);
      }

      buildItems() {
        const groupedItems = new Map();

        this.getSelections().forEach((selection) => {
          const currentQuantity = groupedItems.get(selection.id) || 0;
          groupedItems.set(selection.id, currentQuantity + 1);
        });

        return [...groupedItems].map(([id, quantity]) => ({
          id,
          quantity,
          properties: {
            _bundle_offer: '3_for_2',
          },
        }));
      }

      async addBundle() {
        if (this.getSelections().length !== 3) return;

        this.showError();
        this.toggleLoading(true);

        const sections = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', {
            bubbles: true,
            detail: { sections },
          })
        );

        try {
          const response = await fetch(FoxTheme.routes.cart_add_url, {
            ...FoxTheme.utils.fetchConfig('javascript'),
            body: JSON.stringify({
              items: this.buildItems(),
              sections,
              sections_url: window.location.pathname,
            }),
          });
          const parsedState = await response.json();

          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || parsedState.message || this.dataset.errorMessage);
          }

          const cartResponse = await fetch(FoxTheme.routes.cart_url, {
            ...FoxTheme.utils.fetchConfig('json', 'GET'),
          });
          const cart = await cartResponse.json();
          cart.sections = parsedState.sections;

          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
          document.dispatchEvent(
            new CustomEvent('product-ajax:added', {
              detail: { product: parsedState },
            })
          );

          const cartDrawer = document.querySelector('cart-drawer');
          if (FoxTheme.settings.cartType === 'drawer' && cartDrawer) {
            cartDrawer.show(this.addButton);
          } else if (FoxTheme.settings.cartType === 'page' || document.body.classList.contains('cart-template')) {
            window.location.assign(FoxTheme.routes.cart_url);
          }
        } catch (error) {
          this.showError(error.message || this.dataset.errorMessage);
          document.dispatchEvent(
            new CustomEvent('product-ajax:error', {
              detail: { errorMessage: error.message },
            })
          );
        } finally {
          this.toggleLoading(false);
        }
      }

      showError(message = '') {
        if (!this.errorElement) return;
        this.errorElement.hidden = !message;
        this.errorElement.textContent = message;
      }

      toggleLoading(isLoading) {
        this.addButton.classList.toggle('btn--loading', isLoading);
        this.addButton.disabled = isLoading || this.getSelections().length !== 3;
        this.addButton.setAttribute('aria-disabled', String(this.addButton.disabled));
      }
    }
  );
}
